import React from 'react'
import PropTypes from 'prop-types'
import styled, {css} from 'styled-components'
import {DataTableCell as RmwcDataTableCell} from '@rmwc/data-table'
import '@rmwc/data-table/styles'

export const dataTableCellStyles = ({selector = '&&&'}) => css`
  ${selector} {
    font-family: 'Open Sans', sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 14px;
    font-weight: 400;
    line-height: 19.1px;
    color: var(--mdc-theme-primary);
  }
  .mdc-data-table__row--selected ${selector}:before {
    background-color: var(--mdc-theme-neutral3);
  }
  .rmwc-data-table__row--activated ${selector} {
    color: var(--mdc-theme-on-primary);
  }
  .rmwc-data-table--sticky-columns-1 ${selector}:nth-child(-n + 1) {
    background-color: inherit;
  }
`

const StyledRmwcDataTableCell = styled(RmwcDataTableCell)`
  ${dataTableCellStyles}
`

const DataTableCell = ({children, ...otherProps}) => (
  <StyledRmwcDataTableCell role="cell" {...otherProps}>
    {children}
  </StyledRmwcDataTableCell>
)

DataTableCell.propTypes = {
  children: PropTypes.any
}

export {DataTableCell}
